import React, { useState } from 'react';
import { FiSearch } from 'react-icons/fi';

const SearchFilter = ({ filters, clusters, gradeLevels, campuses, onFilterChange }) => {
  const [searchInput, setSearchInput] = useState(filters.search || '');

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onFilterChange({ search: searchInput });
  };

  const handleClusterChange = (e) => {
    onFilterChange({ cluster: e.target.value });
  };

  const handleGradeLevelChange = (e) => {
    onFilterChange({ gradeLevel: e.target.value });
  };

  const handleCampusChange = (e) => {
    onFilterChange({ campus: e.target.value });
  };

  const handleSortChange = (e) => {
    onFilterChange({ sortOrder: e.target.value });
  };

  const handleCompletionChange = (e) => {
    onFilterChange({ completion: e.target.value });
  };

  const isAllStudentsView = filters.view === 'all';

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 ${isAllStudentsView ? 'lg:grid-cols-6' : 'lg:grid-cols-5'}`}>
        {/* Search */}
        <form onSubmit={handleSearchSubmit} className="flex md:col-span-2 lg:col-span-1">
          <div className="relative flex-1">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder={isAllStudentsView ? 'Search by name or Student ID...' : 'Search by Student ID...'}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-l-md focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
            />
          </div>
          <button
            type="submit"
            className="px-4 py-2 bg-primary-600 text-white rounded-r-md hover:bg-primary-700 transition-colors"
          >
            Search
          </button>
        </form>

        {/* Completion Filter (All Students view only) */}
        {isAllStudentsView && (
          <select
            value={filters.completion || ''}
            onChange={handleCompletionChange}
            className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
          >
            <option value="">Completed + Not Completed</option>
            <option value="completed">Completed Only</option>
            <option value="not_completed">Not Completed Only</option>
          </select>
        )}

        {/* Cluster Filter */}
        <select
          value={filters.cluster || ''}
          onChange={handleClusterChange}
          className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
        >
          <option value="">All Clusters</option>
          {clusters.map((cluster, index) => {
            // Handle both object format {careerCluster: "..."} and string format
            const clusterName = typeof cluster === 'object' ? cluster.careerCluster : cluster;
            return (
              <option key={index} value={clusterName}>
                {clusterName}
              </option>
            );
          })}
        </select>

        {/* Grade Level Filter */}
        <select
          value={filters.gradeLevel || ''}
          onChange={handleGradeLevelChange}
          className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
        >
          <option value="">All Grades</option>
          {gradeLevels && gradeLevels.map((grade) => (
            <option key={grade} value={grade}>
              Grade {grade}
            </option>
          ))}
        </select>

        {/* Campus Filter */}
        <select
          value={filters.campus || ''}
          onChange={handleCampusChange}
          className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
        >
          <option value="">All Campuses</option>
          {campuses && campuses.map((campus) => (
            <option key={campus} value={campus}>
              {campus}
            </option>
          ))}
        </select>

        {/* Sort Order */}
        <select
          value={filters.sortOrder || 'desc'}
          onChange={handleSortChange}
          className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
        >
          <option value="desc">Newest First</option>
          <option value="asc">Oldest First</option>
        </select>
      </div>
    </div>
  );
};

export default SearchFilter;
